'use client';
import styled from 'styled-components';

export const StyledStarterBoxCheckoutSummary = styled.div`
  margin: ${props => props.theme.spacing(2, 0)};
`;

export const SummaryCardContent = styled.div`
  display: flex;
  width: 100%;
  align-items: flex-start;
  justify-content: space-between;
`;

export const Headline = styled.h3`
  ${props => props.theme.typography.heading6};
  margin-bottom: ${props => props.theme.spacing(2)};
  max-width: 120px;
  overflow-wrap: break-word;
`;

export const Pricing = styled.div`
  ${props => props.theme.typography.heading6};
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  margin-left: ${props => props.theme.spacing(2)};
`;

export const Price = styled.p`
  color: ${props => props.theme.colors.text.secondary};
  font-weight: normal;
  text-decoration-line: line-through;
`;

export const PriceWithDiscount = styled.p`
  margin-top: ${props => props.theme.spacing(1)};
`;

export const BoldText = styled.span`
  ${props => props.theme.typography.bodyBold}
  color: ${props =>
    props.theme.colors.get(props.color, props.theme.colors.text.secondary)};
`;

export const LightText = styled.span`
  ${props => props.theme.typography.bodyBold}
  color: ${props => props.theme.colors.border.fur};
`;
